import React from 'react';
import xdk from '@accedo/xdk-core';
import PropTypes from 'prop-types';
import logger from '@accedo/xdk-log';
import screenfull from 'screenfull';
import styles from './PlayerFullscreenButton.scss';
import fullscreenIcon from '#/static/images/icons/player-fullscreen.svg';

const { debug } = logger({
  logTag: '[widgets/buttons/PlayerFullscreenButton]',
});

const PlayerFullscreenButton = ({ fullscreenLayout, container }) => {
  return (
    <img
      className={`${styles.playerFullscreenButton} ${
        fullscreenLayout ? styles.fullscreen : styles.background
      }`}
      src={fullscreenIcon}
      onClick={async () => {
        if (screenfull.isFullscreen) {
          screenfull.exit();
        } else {
          try {
            // Required to pause, transition, then play for Safari bug fix
            // Safari automatically pauses the video when changing window screen or
            // transitioning to fullscreen, this triggered error state in player in a loop
            const shouldPauseBeforeTransition =
              xdk.media?.getState() !== 'paused' &&
              xdk.media?.getState() !== 'stopped';
            shouldPauseBeforeTransition && xdk.media?.pause();
            await screenfull.request(container);
            shouldPauseBeforeTransition && xdk.media?.play();
          } catch (e) {
            debug(`Failed to enter fullscreen: ${e.toString()}`);
          }
        }
      }}
      alt="Fullscreen"
      role="presentation"
    />
  );
};
PlayerFullscreenButton.propTypes = {
  fullscreenLayout: PropTypes.bool,
  container: PropTypes.object,
};

export default PlayerFullscreenButton;
